var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.homeData)?_c('hheader',{attrs:{"homeData":_vm.homeData}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row mainContain"},[_c('router-view')],1),_vm._v(" "),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }